import { SfccRefundMethod } from "@redotech/congo-enums/sfcc-refund-method";
import type { infer as zInfer } from "zod";
import * as z from "zod";
import { commerceCloudIntegrationId } from "./list-commerce-cloud-integrations";

export const getCommerceCloudRefundMethod = {
  name: "getCommerceCloudRefundMethod" as const,
  input: z.object({ integrationId: commerceCloudIntegrationId }),
  output: z.union([
    z.object({ refundMethod: z.enum(SfccRefundMethod) }),
    z.undefined(),
  ]),
};

export type CommerceCloudRefundMethod = zInfer<
  typeof getCommerceCloudRefundMethod.output
>;
